import * as types from './mutation-types'

const mutations = {
  [types.SET_CART_DOT] (state, cartDot) {
    state.cartDot = cartDot
  },
  [types.SET_CART_NUM] (state, cartNum) {
    state.cartNum = cartNum
  },
  [types.SET_CART] (state, cart) {
    state.cart = cart
  },
  [types.SET_MSGNUM] (state, msgNum) {
    state.msgNum = msgNum
  }
}

export default mutations



// WEBPACK FOOTER //
// ./src/store/mutations.js